import { createContext } from 'react';

import type { RealtimeManager } from './manager';

export const RealtimeContext = createContext<RealtimeManager | null>(null);
